const listeners = new Set();

const initial = {
  user: null,
  currentCollocation: null,
  currentProgress: null,
  baseline: null,
  drum: [],
  stats: null,
  form: null,
  dailyGoal: null,
  ui: { loading: false, error: null },
};

function createStore(initialState) {
  const state = structuredClone(initialState);

  const notify = (keys) => {
    for (const fn of listeners) fn(state, keys);
  };

  const handler = {
    set(target, key, value) {
      const prev = target[key];
      if (prev === value) return true;
      target[key] = value;
      notify([key]);
      return true;
    },
  };

  const wrap = (obj, path = []) => {
    for (const k of Object.keys(obj)) {
      if (obj[k] && typeof obj[k] === 'object' && !Array.isArray(obj[k])) {
        obj[k] = wrap(obj[k], [...path, k]);
      }
    }
    return new Proxy(obj, handler);
  };

  return wrap(state);
}

export const store = createStore(initial);

export function subscribe(fn) {
  listeners.add(fn);
  return () => listeners.delete(fn);
}

export function resetStore() {
  store.user = null;
  store.currentCollocation = null;
  store.currentProgress = null;
  store.baseline = null;
  store.drum = [];
  store.stats = null;
  store.form = null;
  store.dailyGoal = null;
}
